export enum WorkStartTypeEnum {
  'С момента подписания договора',
  'С момента оплаты',
}
